// @ts-nocheck
import React, { useContext, useState, useEffect } from 'react';
import Context from '../../context/Context';
import { URL, URL_FRONT } from '../../service/Service';
import { useParams } from 'react-router-dom';
import { editFormElement } from '../../context/forms/FormsAction';
import Header from '../TitleAndSubtitle';
import TooltipMouseFollow from '../TooltipMouseFollow';

const DonationEditWizard = ({ elementInfo, userRole }) => {
	const { idform, idformelement } = useParams();
	const { dispatch } = useContext(Context);

	const [label, setLabel] = useState(elementInfo.label);
	const [value, setValue] = useState(elementInfo.element_value); // unified with PriceEditWizard
	const displayValue = value.replace(/\./g, ',');

	const [initialLabel] = useState(elementInfo.label);
	const [initialValue] = useState(elementInfo.element_value);
	const [success, setSuccess] = useState(false);

	useEffect(() => {
		setValue(elementInfo.element_value || '');
		setLabel(elementInfo.label || '');
	}, [elementInfo.element_value, elementInfo.label]);

	const handleChange = (e) => {
		const regex = /^\d*\.?\d{0,2}$/;
		let inputValue = e.target.value.replace(/,/g, '.');

		if (regex.test(inputValue) || inputValue === '') {
			setValue(inputValue);
		}
	};

	const updateHandler = async () => {
		const url = `${URL}/api/forms/${idform}/formelements/${idformelement}`;
		const request = {
			method: 'PATCH',
			headers: {
				'Content-type': 'application/json',
				Accept: 'application/json',
			},
			body: JSON.stringify({ value, label }),
		};

		const response = await fetch(url, request);
		if (response.status === 200) {
			setSuccess(true);
		}

		editFormElement(url, request, dispatch);
	};

	const deleteElementHandler = (elementId) => {
		const url = `${URL}/api/forms/${idform}/formelements/${elementId}`;
		const request = {
			method: 'DELETE',
			headers: {
				'Content-type': 'application/json',
				Accept: 'application/json',
			},
		};
		editFormElement(url, request, dispatch);
	};

	const handleCancel = (e) => {
		e.preventDefault();
		if (initialLabel === '' && initialValue === '') {
			deleteElementHandler(idformelement);
		}
		window.history.back();
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		updateHandler();
		setTimeout(() => {
			window.location.href =
				userRole === 'ADMIN'
					? `${URL_FRONT}/admin/forms/${idform}/formwizard/1`
					: `${URL_FRONT}/forms/${idform}/formwizard/1`;
		}, 1000);
	};

	return (
		<div className='p-5'>
			<div className='mb-5'></div>
			<div className="flex flex-col md:flex-row justify-between items-center">
				<Header title="Editar Doação" />
			</div>

			<form onSubmit={handleSubmit} className="bg-white p-6 rounded-lg shadow-md">
				<div className="mb-4">
					<label className="p-2.5 text-sm font-bold text-gray-900 flex items-center gap-2">
						Legenda
						<TooltipMouseFollow message="Texto que será exibido como título do campo no formulário." />
					</label>
					<input
						id="label-input"
						className="mt-1 w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
						type="text"
						value={label}
						onChange={e => setLabel(e.target.value)}
					/>
				</div>
				<div className="mb-10">
					<label htmlFor="donation-input" className="p-2.5 text-sm font-bold text-gray-900 flex items-center gap-2">
						Valor sugerido (€)
						<TooltipMouseFollow message="Este valor será sugerido como doação ao utilizador, mas ele pode alterá-lo." />
					</label>
					<input
						id="donation-input"
						className="mt-1 w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5"
						type="text"
						value={displayValue}
						onChange={handleChange}
					/>
				</div>
				<div className="flex justify-end">
					<button className="mr-4 bg-green-cl hover:bg-opacity-80 text-white py-2 px-4 rounded" onClick={handleCancel}>
						Cancelar
					</button>
					<button className="bg-green-cl hover:bg-opacity-80 text-white py-2 px-4 rounded">
						Guardar
					</button>
				</div>
			</form>

			{success && (
				<div className="fixed bottom-0 right-0 mb-4 mr-4 animate-slide-up">
					<div className="mt-10 relative flex flex-col sm:flex-row sm:items-center bg-white shadow rounded-md py-5 pl-6 pr-8 sm:pr-6">
						<button className="absolute top-0 right-0 px-2 py-1" type='button' onClick={() => setSuccess(false)}>x</button>
						<div className="flex flex-row items-center border-b sm:border-b-0 w-full sm:w-auto pb-4 sm:pb-0">
							<div className="text-green-500">
								<svg className="w-6 sm:w-5 h-6 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"
									 xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round"
																			  strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
							</div>
							<div className="text-sm font-medium ml-3">Sucesso:</div>
						</div>
						<div className="text-sm tracking-wide text-gray-500 mt-4 sm:mt-0 sm:ml-4">
							Dados guardados com sucesso!
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default DonationEditWizard;